import React from "react";
import "../blocks/ImageGrid.css";

import image1 from "../images/Willy_Miguel_Zafarraya.jpg";
import image2 from "../images/Miguel_zafarraya.jpg";
import image3 from "../images/MiquelAngel_Zafarraya.jpg";

function ImageGrid() {
  const images = [image1, image2, image3];
  return (
    <section id="facilities">
      <h2 className="image-grid__title">La banda en directo</h2>
      <div className="image-grid">
        {images.map((image, index) => (
          <div key={index} className="image-grid__item">
            <img src={image} alt={`Carmen Supermarket ${index + 1}`} />
          </div>
        ))}
      </div>
    </section>
  );
}

export default ImageGrid;
